import React, { Component } from 'react'
import OrganizationComponent from '../../Organization/components/organizationComponent';
import { HeartRunnerRegister,fetchHeartRunnerOrg } from '../actions/registrationAction';
import  HeartRunnerRegisterForm  from '../../HeartRunnerRegistration/components/registrationComponent';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class heartRunnerRegistrationContainer extends Component {
    componentWillMount() {
   
      
        this.props.actions.fetchHeartRunnerOrg(this.props.dispatch)
    }
    registerHeartRunner=(data)=>{
        this.props.actions.HeartRunnerRegister(
            data,
            this.props.dispatch
        )
    }

    render() {
    
        return (
                <HeartRunnerRegisterForm 
                    registerHeartRunner={this.registerHeartRunner}
                    RegisterInfo={this.props.RegisterInfo}
                />
            )

    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            HeartRunnerRegister,
            fetchHeartRunnerOrg
        },
            dispatch)
    };
}

function mapStateToProps({ heartRunnerRegistrationReducer }) {
    console.log(heartRunnerRegistrationReducer)
    return {
        RegisterInfo: {
            heartRunnerOrgInfo:heartRunnerRegistrationReducer.heartRunnerOrgInfo,
            isLoading: heartRunnerRegistrationReducer.isLoading,
            Message: heartRunnerRegistrationReducer.Message,
            statusCode:heartRunnerRegistrationReducer.statusCode
        }
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(heartRunnerRegistrationContainer)
